<template>
  <cx-showcase-section :name="name" :link="link" class="cx-toggle-showcase">
    Variant Primary
    <div class="cxu-d-flex">
      <div class="cxu-p-10"><cx-toggle icon="mdi-eye" :active="primary.active" :loading="primary.loading" @click="toggle(primary)" tooltip="this is primary CxToggle"/></div>
      <div class="cxu-p-10"><cx-toggle icon="mdi-eye" :active="false" :disabled="true" tooltip="toolpip for disabled CxToggle is not visible"/></div>
    </div>

    Variant Secondary
    <div class="cxu-d-flex">
      <div class="cxu-p-10"><cx-toggle icon="mdi-eye" :active="secondary.active" variantSecondary :loading="secondary.loading" @click="toggle(secondary)" tooltip="this is secondary CxToggle"/></div>
      <div class="cxu-p-10"><cx-toggle icon="mdi-eye" :active="false" variantSecondary :disabled="true"/></div>
    </div>

    Custom Css
    <div class="cxu-p-10"><cx-toggle icon="mdi-eye" :active="custom.active" class="custom-css" :loading="custom.loading" :iconSize="20" @click="toggle(custom)" tooltip="this is custom CxToggle"/></div>
  </cx-showcase-section>
</template>

<script>
import CxShowcaseSection from '../CxShowcaseSection';
import CxToggle from '@/components/CxToggle';

export default {
  name: 'CxToggleShowcase',
  components: {
    CxShowcaseSection,
    CxToggle
  },
  data() {
    return {
      name: 'CxToggle',
      link: 'https://miro.com/app/board/o9J_lDPoVY8=/?moveToWidget=3074457359611272577&cot=14',
      primary: {
        active: false,
        loading: false
      },
      secondary: {
        active: false,
        loading: false
      },
      custom: {
        active: false,
        loading: false
      }
    };
  },
  methods: {
    async toggle(item) {
      item.loading = true;
      await Promise.resolve(setTimeout(1000));
      item.loading = false;
      item.active = !item.active;
    },
  },
};

</script>

<style lang="less">
@import '../../../common';

.cx-toggle-showcase {

  .cx-toggle.cx-button.custom-css {
    padding: 10px;
    background-color: rgba(253, 4, 4, 0.432);
    &.cx-button:hover:not(.cx-toggle--disabled):not(.cx-toggle--loading) {
      background-color: lighten(rgba(253, 4, 4, 0.432), 10%);
      color: @textColor;
    }
    &.cx-toggle--active {
      color: @textColor;
      background-color: red;
    }
  }

}

</style>